import { Badge, Box, Group, Stack, Table, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import { NO_OPTIONS_TEXT, OPTIONS_PREVIEW_ONLY_TEXT, REQUIRED_LABEL } from '../constants';
import {
  includedAllowanceLabel,
  isOptionGroupRequired,
  optionPriceLabel,
  selectionRuleLabel,
} from '../helpers';
import type { MenuOptionGroup } from '../types';

type MenuItemOptionGroupsProps = {
  optionGroups: MenuOptionGroup[];
};

export const MenuItemOptionGroups: React.FC<MenuItemOptionGroupsProps> = ({ optionGroups }) => {
  if (optionGroups.length === 0) {
    return (
      <Text size="sm" c="dimmed">
        {NO_OPTIONS_TEXT}
      </Text>
    );
  }

  return (
    <Stack gap="md">
      <Group gap={4} justify="flex-end" c="dimmed">
        <IconInfoCircle size={16} />
        <Text size="xs" fw={600} tt="uppercase">
          {OPTIONS_PREVIEW_ONLY_TEXT}
        </Text>
      </Group>

      {optionGroups.map((group) => {
        const includedLabel = includedAllowanceLabel(group);

        return (
          <Stack key={group.id} gap={8}>
            <Box>
              <Text size="xs" fw={600}>
                {group.nameForVendor}
              </Text>
              <Group gap={6}>
                <Text size="xs" c="dimmed">
                  {selectionRuleLabel(group)}
                </Text>
                {isOptionGroupRequired(group) && (
                  <Badge size="xs" variant="light" color="gray">
                    {REQUIRED_LABEL}
                  </Badge>
                )}
              </Group>
              {includedLabel ? (
                <Text size="xs" c="dimmed">
                  {includedLabel}
                </Text>
              ) : null}
            </Box>

            <Table
              striped="even"
              horizontalSpacing={12}
              verticalSpacing={6}
              fz="xs"
              withRowBorders
              style={{
                borderTop: '1px solid var(--mantine-color-gray-3)',
                borderBottom: '1px solid var(--mantine-color-gray-3)',
              }}
            >
              <Table.Tbody>
                {group.options.map((option) => (
                  <Table.Tr key={option.id}>
                    <Table.Td w="50%">{option.nameForVendor}</Table.Td>
                    <Table.Td w="50%">{optionPriceLabel(option)}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </Stack>
        );
      })}
    </Stack>
  );
};
